import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { acceptInvite, type AcceptInvitePayload } from '@entities/admin';
import { useSessionStore } from '@entities/session';
import { ROUTES } from '@shared/config/routes';

export function useAcceptInvite() {
  const navigate = useNavigate();
  const setAuthenticated = useSessionStore((s) => s.setAuthenticated);

  return useMutation({
    mutationFn: (payload: AcceptInvitePayload) => acceptInvite(payload),
    onSuccess: ({ tokens, identity }) => {
      setAuthenticated(tokens, identity);
      navigate(ROUTES.dashboard, { replace: true });
    },
  });
}
